import React from "react";
import Layout from "../../layout/Layout";
import { NavLink, useNavigate } from "react-router-dom";
import { BsGridFill } from "react-icons/bs";
import { FaRegListAlt } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { RiLockPasswordLine, RiLogoutCircleLine } from "react-icons/ri";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/features/userSlice";

function SideBar({ children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    dispatch(logout());
    toast.success("Logged out successfully");
    navigate("/");
  };

  const SideLink = [
    {
      name: "Dashboard",
      link: "/dashboard",
      icon: BsGridFill,
    },
    {
      name: "Booking",
      link: "/dashboard/listofbooking",
      icon: FaRegListAlt,
    },
    {
      name: "Update Profile",
      link: "/dashboard/profile",
      icon: FiSettings,
    },
    {
      name: "Change Password",
      link: "/dashboard/password",
      icon: RiLockPasswordLine,
    },
  ];

  const active = "bg-yellow-500 text-white";
  const hover = "hover:text-yellow-500 hover:bg-deepGray hover:bg-gray-700";
  const inActive =
    "rounded font-medium text-sm transitions flex gap-3 items-center p-4";

  return (
    <Layout header={true}>
      <div className="bg-gray-900 text-white pb-8 pt-12 px-4">
        <div className="min-h-screen container mx-auto px-2">
          <div className="xl:grid grid-cols-8 gap-10 items-start md:py-12 py-6">
            <div className="sticky col-span-2 bg-gray-800 p-6 rounded-md xl:mb-0 mb-5">
              {SideLink.map((item, i) => (
                <NavLink
                  key={i}
                  to={item.link}
                  end={item.link === "/dashboard"}
                  className={({ isActive }) =>
                    `${inActive} ${isActive ? active : hover} text-white`
                  }
                >
                  <item.icon className="text-lg" />
                  <p>{item.name}</p>
                </NavLink>
              ))}
              <button
                onClick={logoutHandler}
                className={`${inActive} ${hover} w-full text-white hover:bg-gray-700`}
              >
                <RiLogoutCircleLine className="text-lg" />
                <p>Log Out</p>
              </button>
            </div>

            <div
              data-aos="fade-up"
              data-aos-offset="200"
              data-aos-delay="10"
              data-aos-duration="1000"
              className="col-span-6 rounded-md bg-gray-800 p-6"
            >
              {children}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default SideBar;
